export var StudyPackButtonTitle;

(function (StudyPackButtonTitle) {
  StudyPackButtonTitle["StudyPack"] = "Study Pack";
  StudyPackButtonTitle["StudyPackLive"] = "Study Pack Live";
})(StudyPackButtonTitle || (StudyPackButtonTitle = {}));

export var StudyPackButtonTestId;

(function (StudyPackButtonTestId) {
  StudyPackButtonTestId["StudyPack"] = "studyPack-onboarding-button";
  StudyPackButtonTestId["StudyPackIcon"] = "studyPack-onboarding-icon";
  StudyPackButtonTestId["StudyPackLive"] = "studyPackLive-onboarding-button";
})(StudyPackButtonTestId || (StudyPackButtonTestId = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/StudyPackButton/types.js
// module id = 5600
// module chunks = 11